export const environment = {
  production: true,
  buildId: '2532766166817551',
  configFile: 'config.json',
};
